import { useState } from "react";
import { getTests } from "./../services/Model";
import { ToastContainer, toast } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

function Home() {
  const [patientID, setPID] = useState("");
  const [testID, setTID] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getPatientTests = async () => {
    if (!patientID || !testID) {
      toast.error("Please enter both Patient ID and Test ID");
      return;
    }

    setLoading(true);

    // Strip leading zeros so "001234" and "1234" both match the backend record
    const normalizedPID = patientID.replace(/^0+(?=\d)/, "");

    try {
      let testsFound = await getTests(normalizedPID, testID);
      testsFound = testsFound.data.rows;

      if (testsFound.length > 0) {
        toast.success(`${testsFound.length} Tests found`);
        // Navigate to report page with results
        navigate(`/report/all/${normalizedPID}/${testID}`);
      } else {
        toast.error("No tests found for the provided IDs");
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        toast.error(err.response.data);
      } else {
        toast.error("Error fetching test results");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <Helmet>
        <title>FOH Lab - Test Reports</title>
      </Helmet>

      <div className="row min-vh-100">
        <div className="col-lg-6 d-flex align-items-center justify-content-center p-0 position-relative">
          <img
            src="/lab-foh.jpg"
            alt="FOH Lab"
            className="img-fluid w-100 h-100"
            style={{ objectFit: "cover" }}
          />
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
          >
            <div className="text-center text-white">
              <i className="fas fa-flask fs-1 mb-3 text-white"></i>
              <h1 className="fw-bold mb-2">FOH LAB</h1>
              <p className="fs-5 mb-0"><i className="fas fa-award me-2"></i>Name of Excellence</p>
            </div>
          </div>
        </div>

        <div className="col-lg-6 d-flex align-items-center justify-content-center p-4">
          <div className="w-100" style={{ maxWidth: "400px" }}>
            <div className="card shadow-sm">
              <div className="card-body p-4">
                <form onSubmit={(e) => { e.preventDefault(); getPatientTests(); }}>
                <div className="mb-3">
                  <label className="form-label fw-medium"><i className="fas fa-user me-2"></i>Patient ID</label>
                  <input
                    onChange={(e) => setPID(e.target.value)}
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Enter Patient ID"
                    value={patientID}
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label fw-medium"><i className="fas fa-vial me-2"></i>Test ID</label>
                  <input
                    onChange={(e) => setTID(e.target.value)}
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Enter Test ID"
                    value={testID}
                  />
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  className="w-100 py-2"
                  disabled={loading}
                >
                  {loading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                  )}
                  {loading ? "Searching..." : <><i className="fas fa-file-medical me-2"></i>Get My Report</>}
                </Button>
                </form>
              </div>
            </div>

            <div className="text-center mt-3">
              <small className="text-muted">
                Need help? Contact FOH Lab for assistance with your test
                results.
              </small>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default Home;
